export default "__VITE_ASSET__CHH4EySL__"